import { Form } from "antd";
import PrimaryButton from "../../components/atomics/primary-button";

import { t } from "../../translate";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Lock } from "../../components/assets/ic_lock.svg";
import styles from "../../components/styles/auth-layout.module.scss";
import SmsInput from "../../components/atomics/otp-input-v2";
import { useQuery } from "../../helpers/use-query";
import { useEffect, useState } from "react";
import { useSecureService } from "../../store/service-atoms";
import { RoleType, loadingAtom, postloginMessageAtom } from "../../store/global-atoms";
import { useAtom } from "jotai";
import SecondaryButton from "../../components/atomics/secondary-button";
import TextButton from "../../components/atomics/text-button";
import SignupLayout from "../../components/layouts/signup-layout";

import { DeviceType } from "../../service";
import getDeviceType from "../../helpers/get-user-device-type";
const maxCount = 120;
const OTPVerification = () => {
    const query = useQuery();
    const userId = query.get("id") || "0";
    const operation = query.get("op") || "";
    const email = query.get("email") || "";
    const roleQuery = (query.get("role") as RoleType) || "customer";
    const fromRequest = query.get("request") ? "&request=true" : "";
    const navigate = useNavigate();
    const [loading] = useAtom(loadingAtom);
    const [counter, setCounter] = useState(maxCount);
    const { doResendActivationCode, doActivateAccount, doResendAccountActivationCode, doResetPasswordOTP } = useSecureService();
    const [otpCode, setOtpCode] = useState<string>("");
    const [, message] = useAtom(postloginMessageAtom);

    const handleSmsChange = (code: string) => {
        setOtpCode(code); // Child'dan gelen SMS kodunu al
    };
    const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.Null);

    useEffect(() => {
        const type = getDeviceType();
        setDeviceType(type);
    }, []);
    const formFinishHandler = async (params: { sms: string }) => {
        if (operation === "forgot-password") {
            const result = await doResetPasswordOTP(roleQuery, {
                code: otpCode,
                id: parseInt(userId),
            });
            if (result) {
                navigate("/reset-password?email=" + email + "&otp=" + otpCode + "&role=" + roleQuery);
            }
        }else if (operation === "register") {
            const result = await doActivateAccount(roleQuery, {
                code: otpCode,
                id: parseInt(userId),
                deviceTpye: deviceType,
            });
            if (result) {
                message({ message: t("lessor.createUser.success"), type: "success" });
                navigate("/dashboard?role=" + roleQuery + fromRequest);
            } else {
               
            }
        }
    };

    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    const resendClick = () => {
        if (operation === "register") doResendAccountActivationCode(roleQuery, parseInt(userId));
        else doResendActivationCode(roleQuery, parseInt(userId));
        setCounter(maxCount);
    };

    return (
        <SignupLayout description={t("")}  className={styles.verticalCentralizedFlexContainer} descriptionBold={true} >
            <div className={styles.verticalCentralizedFlexContainer}>
                <div className={styles.smsVerificationIconCycle}>
                    <Lock width={"3.75rem"} height={"3.75rem"} />
                </div>

                <div>
                    <p className={styles.smsVerificationNumber}>{email}</p>
                    <p className={styles.smsVerificationInfo}>{t("email-verification.info")}</p>
                </div>
            </div>
            <Form name="normal_login" className={styles.smsVerificationForm} layout="vertical" onFinish={formFinishHandler}>
                <div className={styles.smsInputContainer}>
                    <SmsInput
                        onChange={handleSmsChange}
                        placeholder={t("email-verification.otpInput.placeholder")}
                        validationMessage={t("email-verification.otpInput.validationMessage")}
                        label={t("email-verification.otpInput.label")}
                    />
                </div>
                <div>
                    <PrimaryButton loading={loading} htmlType="submit">
                        {t("email-verification.verifyCode")}
                    </PrimaryButton>
                </div>
                <div>
                    <SecondaryButton onClick={() => resendClick()} type="link" disabled={counter !== 0}>
                        {t("email-verification.resend")}
                        {counter !== 0 && <span>{`(${counter} s)`}</span>}
                    </SecondaryButton>
                </div>
                <div>
                    <TextButton
                        style={{ marginTop: "1rem", width: "100%", color: "#949394" }}
                        onClick={() => (window.location.href = "tel:02127060330")}
                        type="link"
                    >
                        <p style={{ color: "#949394", textDecoration: "underline" }}>{t("sms-verification.signupProblem")}</p>
                    </TextButton>
                </div>
            </Form>
        </SignupLayout>
    );
};

export default OTPVerification;
